<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Catgorias - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'download-categories'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-download-category :btnLabel="btnLabel"></form-download-category>
</span>
</template>

<script>
import FormDownloadCategoryComponent from "./partial/FormDownloadCategoryComponent";

export default {
    name: "AddDownloadCategoryComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formDownloadCategory: FormDownloadCategoryComponent,
    }
};
</script>

<style scoped>

</style>
